/** Activity Log / UserGuide 共用：關鍵字黃底標註 */

export const escapeRegExp = str => String(str).replace(/[.*+?^${}()|[\]\\]/g, '\\$&')

export const splitHighlightFragments = (text, keyword) => {
  if (!keyword) return [{ text: text ?? '', highlight: false }]
  return String(text ?? '')
    .split(new RegExp(`(${escapeRegExp(keyword)})`, 'gi'))
    .filter(part => part !== '')
    .map(part => ({
      text: part,
      highlight: part.toLowerCase() === String(keyword).toLowerCase(),
    }))
}

/** 清除先前掛上的 <mark class="search-highlight"> */
export const clearDomSearchHighlight = (root) => {
  if (!root?.querySelectorAll) return
  root.querySelectorAll('mark.search-highlight').forEach((mark) => {
    const parent = mark.parentNode
    if (!parent) return
    parent.replaceChild(document.createTextNode(mark.textContent || ''), mark)
    parent.normalize()
  })
}

/**
 * 在 DOM 文字節點標黃；skipSelectors 內的子樹略過（如 Platforms 設定）
 * @param {Element} root
 * @param {string} keyword
 * @param {{ skipSelectors?: string[] }} [options]
 */
export const applyDomSearchHighlight = (root, keyword, { skipSelectors = [] } = {}) => {
  clearDomSearchHighlight(root)
  const k = String(keyword || '').trim()
  if (!k || !root) return

  const isInsideSkip = (el) => {
    if (!el) return false
    return skipSelectors.some(sel => el.closest?.(sel))
  }

  const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
    acceptNode(node) {
      if (!node.nodeValue || !node.nodeValue.trim()) return NodeFilter.FILTER_REJECT
      const parent = node.parentElement
      if (!parent) return NodeFilter.FILTER_REJECT
      if (['SCRIPT', 'STYLE', 'TEXTAREA', 'INPUT', 'SELECT'].includes(parent.tagName)) {
        return NodeFilter.FILTER_REJECT
      }
      if (parent.closest?.('mark.search-highlight')) return NodeFilter.FILTER_REJECT
      if (isInsideSkip(parent)) return NodeFilter.FILTER_REJECT
      return NodeFilter.FILTER_ACCEPT
    },
  })

  const textNodes = []
  let node = walker.nextNode()
  while (node) {
    textNodes.push(node)
    node = walker.nextNode()
  }

  const re = new RegExp(`(${escapeRegExp(k)})`, 'gi')
  textNodes.forEach((textNode) => {
    const parts = textNode.nodeValue.split(re)
    if (parts.length <= 1) return
    const fragment = document.createDocumentFragment()
    parts.forEach((part) => {
      if (!part) return
      if (part.toLowerCase() === k.toLowerCase()) {
        const mark = document.createElement('mark')
        mark.className = 'search-highlight'
        mark.textContent = part
        fragment.appendChild(mark)
      } else {
        fragment.appendChild(document.createTextNode(part))
      }
    })
    if (textNode.parentNode) {
      textNode.parentNode.replaceChild(fragment, textNode)
    }
  })
}
